/*
 * Copyright (c) 2023 NEXTWELL INTL SRL. All Rights Reserved.
 * This software is the proprietary information of NEXTWELL INTL SRL.
 * Use is subject to license and non-disclosure terms
 */

import { Rights } from './rights';

export const getCustomerFinancialRights = () => {
  return [Rights.ROLE_ADMIN, Rights.ROLE_CUSTOMER_FINANCIAL, Rights.ROLE_CUSTOMER_ADMIN];
};

export const getCustomerAndEmailAuthFinancialRights = () => {
  return [Rights.ROLE_ADMIN, Rights.ROLE_CUSTOMER_FINANCIAL, Rights.ROLE_CUSTOMER_ADMIN, Rights.ROLE_EMAIL_AUTH];
};

export const getOutboxRights = () => {
  return [Rights.ROLE_ADMIN, Rights.ROLE_CUSTOMER_ADMIN, Rights.ROLE_CUSTOMER_ORDER, Rights.ROLE_SP_FORWARDING];
};

export const getCustomerRights = () => {
  return [Rights.ROLE_ADMIN, Rights.ROLE_CUSTOMER_ADMIN, Rights.ROLE_CUSTOMER_ORDER];
};

export const getCustomerInternalRights = () => {
  return [Rights.ROLE_ADMIN, Rights.ROLE_CUSTOMER_ADMIN, Rights.ROLE_CUSTOMER_ORDER, Rights.ROLE_INTERNAL];
};

export const getCustomerOfferRequestAndOrderRights = () => {
  return [Rights.ROLE_ADMIN, Rights.ROLE_CUSTOMER_ADMIN, Rights.ROLE_CUSTOMER_ORDER, Rights.ROLE_EMAIL_AUTH, Rights.ROLE_CUSTOMER_FINANCIAL, Rights.ROLE_SP_FORWARDING];
};

export const getServiceProviderOfferRequestAndOrderRights = () => {
  return [
    Rights.ROLE_ADMIN,
    Rights.ROLE_SP_ADMIN,
    Rights.ROLE_SP_PLANNER,
    Rights.ROLE_SP_DISPATCHER,
    Rights.ROLE_EMAIL_AUTH,
    Rights.ROLE_SP_FINANCIAL
  ];
};

export const getSPFinancialRights = () => {
  return [Rights.ROLE_ADMIN, Rights.ROLE_SP_ADMIN, Rights.ROLE_SP_FINANCIAL];
};

export const getSPAndEmailAuthFinancialRights = () => {
  return [Rights.ROLE_ADMIN, Rights.ROLE_SP_ADMIN, Rights.ROLE_SP_FINANCIAL, Rights.ROLE_EMAIL_AUTH];
}

export const getFleetRights = () => {
  return [Rights.ROLE_SP_ADMIN, Rights.ROLE_SP_AUTO_PARK];
}

export const getServiceProviderGeneralRights = () => {
  return [Rights.ROLE_ADMIN, Rights.ROLE_SP_ADMIN, Rights.ROLE_SP_PLANNER, Rights.ROLE_SP_DISPATCHER, Rights.ROLE_SP_FORWARDING];
};

export const getServiceProviderAdminRights = () => {
  return [Rights.ROLE_ADMIN, Rights.ROLE_SP_ADMIN];
};

export const getContractRights = () => {
  return [Rights.ROLE_ADMIN, Rights.ROLE_SP_ADMIN, Rights.ROLE_SP_FINANCIAL];
};

export const getOperationalTerritoryRights = () => {
  return [Rights.ROLE_ADMIN, Rights.ROLE_SP_ADMIN, Rights.ROLE_SP_FINANCIAL];
};

export const getAccountsSpContractsRights = () => {
  return [Rights.ROLE_SP_ADMIN, Rights.ROLE_SP_FINANCIAL, Rights.ROLE_EMAIL_AUTH];
};

export const getCustomerContractsRights = () => {
  return [Rights.ROLE_CUSTOMER_ADMIN, Rights.ROLE_CUSTOMER_FINANCIAL];
};

export const getComplaintRights = () => {
  return [
    Rights.ROLE_ADMIN,
    Rights.ROLE_SP_ADMIN,
    Rights.ROLE_SP_FINANCIAL,
    Rights.ROLE_CUSTOMER_FINANCIAL,
    Rights.ROLE_CUSTOMER_ADMIN,
    Rights.ROLE_SP_PLANNER,
    Rights.ROLE_CUSTOMER_ORDER,
    Rights.ROLE_SP_DISPATCHER
  ];
};

export const getCustomerServiceProviderCommonRights = () => {
  return [
    Rights.ROLE_ADMIN,
    Rights.ROLE_SP_ADMIN,
    Rights.ROLE_CUSTOMER_ADMIN,
    Rights.ROLE_SP_PLANNER,
    Rights.ROLE_CUSTOMER_ORDER,
    Rights.ROLE_SP_DISPATCHER,
    Rights.ROLE_DETALII_COMPANIE
  ];
};

export const getGeneralOrderRights = () => {
  return [
    Rights.ROLE_ADMIN,
    Rights.ROLE_SP_ADMIN,
    Rights.ROLE_CUSTOMER_ADMIN,
    Rights.ROLE_SP_PLANNER,
    Rights.ROLE_CUSTOMER_ORDER,
    Rights.ROLE_SP_DISPATCHER,
    Rights.ROLE_EMAIL_AUTH
  ];
};

export const getRestrictedOrderRights = () => {
  return [
    Rights.ROLE_ADMIN,
    Rights.ROLE_SP_ADMIN,
    Rights.ROLE_CUSTOMER_ADMIN,
    Rights.ROLE_SP_PLANNER,
    Rights.ROLE_CUSTOMER_ORDER,
    Rights.ROLE_SP_DISPATCHER
  ];
};

export const getNamedLocationManageRights = () =>{
  return [
    Rights.ROLE_ADMIN,
    Rights.ROLE_SP_ADMIN,
    Rights.ROLE_SP_PLANNER,
    Rights.ROLE_SP_DISPATCHER,
    Rights.ROLE_SP_FORWARDING
  ];
}

export const getNamedLocationEditRights = () =>  {
  return [
    Rights.ROLE_ADMIN,
    Rights.ROLE_SP_ADMIN,
    Rights.ROLE_SP_PLANNER,
    Rights.ROLE_SP_DISPATCHER,
    Rights.ROLE_SP_FORWARDING,
    Rights.ROLE_CUSTOMER_ADMIN,
    Rights.ROLE_CUSTOMER_ORDER
  ];
}

export const getNamedLocationOwnershipRequestForPlatformAdminRights = () => {
  return [
    Rights.ROLE_SELECT_ITEMS_ADMIN,
    Rights.ROLE_ADMIN
  ];
}

export const getNamedLocationOwnershipRequestForUserRights  = () => {
  return [
    Rights.ROLE_SP_ADMIN,
    Rights.ROLE_CUSTOMER_ADMIN,
    Rights.ROLE_SP_PLANNER,
    Rights.ROLE_CUSTOMER_ORDER,
    Rights.ROLE_SP_DISPATCHER
  ];
}

export const getNamedLocationOwnershipRequestRights = () =>{
  return [
    Rights.ROLE_SELECT_ITEMS_ADMIN,
    Rights.ROLE_ADMIN,
    Rights.ROLE_SP_ADMIN,
    Rights.ROLE_CUSTOMER_ADMIN,
    Rights.ROLE_SP_PLANNER,
    Rights.ROLE_CUSTOMER_ORDER,
    Rights.ROLE_SP_DISPATCHER
  ];
}

export const getCollaborationRights = () =>{
  return [
    Rights.ROLE_ADMIN,
    Rights.ROLE_SP_ADMIN,
    Rights.ROLE_CUSTOMER_ADMIN,
    Rights.ROLE_SP_PLANNER,
    Rights.ROLE_CUSTOMER_ORDER,
    Rights.ROLE_SP_DISPATCHER
  ];
}

export const getStandardPackagesRights = () => {
  return [Rights.ROLE_SELECT_ITEMS_ADMIN, Rights.ROLE_SP_ADMIN, Rights.ROLE_CUSTOMER_ADMIN];
};

export const getCostsRights = () => {
  return [
    Rights.ROLE_ADMIN,
    Rights.ROLE_SP_ADMIN,
    Rights.ROLE_SP_FINANCIAL,
    Rights.ROLE_CUSTOMER_FINANCIAL,
    Rights.ROLE_CUSTOMER_ADMIN
  ];
};

export const getWarehouseRights = () => {
  return [Rights.ROLE_WAREHOUSE,Rights.ROLE_WAREHOUSE_GATEKEEPER];
};

export const getCashFlowRights = () => {
  return [Rights.ROLE_CUSTOMER_FINANCIAL, Rights.ROLE_SP_FINANCIAL];
};

export const getEFacturaPageRights = () => {
  return [Rights.ROLE_CUSTOMER_FINANCIAL, Rights.ROLE_SP_FINANCIAL];
};

export const getETransportRights = () => {
  return [Rights.ROLE_ETRANSPORT];
};

export const getETransportShipmentOrganizerRights = () => {
  return [Rights.ROLE_ETRANSPORT_SHIPMENT_ORGANIZER];
};

export const getETransportActionsRights = () => {
  return [Rights.ROLE_ETRANSPORT, Rights.ROLE_ETRANSPORT_SHIPMENT_ORGANIZER];
};

export const getExternalOrderRights = () => {
  return [Rights.ROLE_EXTERNAL_ORDER, Rights.ROLE_UNEDIFACT];
}

export const getUNEdifactRights = () => {
  return [Rights.ROLE_UNEDIFACT];
}

export const getPackageTrackingRights = () => {
  return [Rights.ROLE_CUSTOMER_ADMIN, Rights.ROLE_CUSTOMER_ORDER];
}

export const getProductNomenclatureRights = () => {
  return [
    Rights.ROLE_ADMIN,
    Rights.ROLE_SP_ADMIN,
    Rights.ROLE_SP_FINANCIAL,
    Rights.ROLE_SP_PLANNER,
    Rights.ROLE_SP_DISPATCHER,
    Rights.ROLE_SP_SALES,
    Rights.ROLE_SP_SALES_ADMIN,
    Rights.ROLE_SP_FORWARDING,
    Rights.ROLE_CUSTOMER_ORDER,
    Rights.ROLE_CUSTOMER_FINANCIAL,
    Rights.ROLE_CUSTOMER_ADMIN,
    Rights.ROLE_INTERNAL,
    Rights.ROLE_ETRANSPORT
  ];
}

